import React, { FC, useContext, useMemo } from 'react';

import classNames from 'classnames';
import DishDAC from 'app/views/Menu/Menu/DAC/DishDAC';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import { analyticService } from 'global/services';
import css from './AdditionalDishesSelection.module.scss';

import ArrowIcon from './img/stubArrow.component.svg';

// type TypeCardKeys = 'large' | 'small' | 'shop'

export const AdditionalDishesSelection: FC<any> = ({
    dishes,
    options,
    spaDishObserver,
    scrollElementName = '',
}: any) => {
    const {
        title, description,
        rootLayout, cardsLayout,
        isStubNeeded, isLarge,
        onOpenDetails,
        isPriceHidden = false, isAlterImageUsed = false,
    } = options;

    const { onOpenSelection } = useContext<any>(DishesSelectionContext);

    const dishesToRender = useMemo(
        () => (isStubNeeded ? [...dishes].slice(0, 5) : dishes),
        [dishes, isStubNeeded],
    );

    const isSmallTitle = useMemo(
        () => {
            const cardsWithSmallTitle = ['single', 'shop', 'default'];
            return cardsWithSmallTitle.includes(cardsLayout);
        },
        [cardsLayout],
    );

    const titleClasses = classNames({
        [css.additionalDishesTitle]: true,
        [css.shop]: isSmallTitle,
        'subheadings-sh2-medium': !isSmallTitle,
        'subheadings-sh3-medium': isSmallTitle,
    });

    const additionalDishesRootClasses = classNames({
        [css.additionalDishesSelectionRoot]: true,
        [css.large]: isLarge,
    });
    const additionalDishesListClasses = classNames({
        [css.additionalDishesList]: true,
        [css[rootLayout]]: true,
    });

    const handleStubClick = () => {
        onOpenSelection({ tag: '1220' });
        analyticService.push({
            eventName: 'Click_All_Options',
            value: 1,
        });
    };

    return (
        <div className={additionalDishesRootClasses} data-scroll_name={scrollElementName}>
            <div className={titleClasses}>
                {title}
            </div>
            <div className={`body-m-medium ${css.additionalDishesDesc}`}>
                {description}
            </div>
            <div className={additionalDishesListClasses}>
                {dishesToRender.map((d: any) => (
                    <DishDAC
                        id={d.id}
                        cardProps={{
                            isGreen: cardsLayout === 'green',
                            isHits: cardsLayout === 'hits',
                            isShop: cardsLayout === 'shop',
                            isSmall: cardsLayout === 'small',
                            isSingleItem: cardsLayout === 'single',
                            isUpsell: cardsLayout === 'upsell',
                            onOpenDetails,
                            spaDishObserver,
                            isPriceHidden,
                            isAlterImageUsed,
                        }}
                        cardLayout={cardsLayout === 'default' ? 'mobile' : 'small'}
                        key={d.id}
                    />
                ))}
                {isStubNeeded && (
                    <div
                        className={`shadow-l ${css.additionalDishesStub}`}
                        onClick={handleStubClick}
                        role="none"
                    >
                        <div className={css.additionalDishesStubTextContainer}>
                            <div className={`body-s-medium ${css.additionalDishesStubText}`}>Смотреть все</div>
                            <div className={css.additionalDishesStubIcon}>
                                <ArrowIcon />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
